$(document).ready(function(){
$('#shopify-section-cart-template').addClass("cart_show");
  setTimeout(function() {
    $('.oddm_app_description').show();
       $('html, body').animate({
          scrollTop: $('.appjetty-ddm-cart-cal').offset().top - 10
      },800);
  }, 1400);
  $('.cart_skip_btn a').click(function () {
    $('#shopify-section-cart-template').removeClass("cart_show");
    $('.cart_skip_btn').hide();
    $('.cart_popup_left').css("display", "none");
  })
 });